module.exports = __webpack_public_path__ + "img/dellotie1.08bb0d6e.svg";